import createAsyncSlice from "../utils/createAsyncSlice";

const orderItems = createAsyncSlice({
  name: "orderItems",
  initialState: {
    data: [],
  },
});

export const fetchOrderItems = orderItems.asyncAction;
export const { resetState: resetOrderItemsState } = orderItems.actions;
export default orderItems.reducer;
